import React, { useContext, useMemo } from 'react';
import { TextIntermission } from '@stereoagency/ui';
import { LinesContext } from '@/components/LinesContext';
import { parseHtml } from '@/utils';

type Props = {
  data: {
    content?: string
  }
};

export default function NvisoTextIntermission({ data: { content } }: Props) {
  const { enableLines } = useContext(LinesContext);
  const children = useMemo(() => (content ? parseHtml(content) : null), [content]);
  if (!children) return null;

  return (
    <TextIntermission enableLines={enableLines}>{children}</TextIntermission>
  );
}
